
import { defineComponent } from "vue";
import { IPaymentModel, IStudentsModel, IEnrollmentChargesModel } from "@/interfaces/modules";
import PaymentService from "@/api/Collection/EnrollmentPaymentsService";
import StudentService from "@/api/Aula/StudentsService";
import EnrollmentChargesService from "@/api/Collection/EnrollmentChargesService";
import store from "@/store";

export default defineComponent({
  name: "PaymentsContent",
  props: ['record'],
  data() {
    return {
      students: [] as IStudentsModel[],
      charges: [] as IEnrollmentChargesModel[],
      form: {
        loading: true,
        dialog: false,
        valid: false,
        wasValidated: false,
        record: {} as IPaymentModel,
        rules: {
          required: [(v: any) => !!v || "Este campo es requerido"],
        },
      },
      paymentOptions: ['PAGADO', 'PAGO PARCIAL', 'PENDIENTE POR APLICAR', 'EN REVISION', 'RECHAZADO'],
      methodOfPayments: ['TRANSFERENCIA', 'EFECTIVO', 'BANCOLOMBIA', 'NEQUI', 'DAVIPLATA', 'CHEQUE', 'OTROS'],
      table: {
        filters: { search: "" },
        currentPage: 1,
        loading: false,
        headers: [
          { key: "PaymentDate", label: "Fecha", sortable: true },
          { key: "Amount", label: "Valor", sortable: true },
          { key: "Method", label: "Método", sortable: true },
          { key: "Reference", label: "Referencia", sortable: true },
          { key: "Status", label: "Estado", sortable: true },
          { key: "CreatedByFormat", label: "Creación", sortable: true },
          { key: "ModifiedByFormat", label: "Última modificación", sortable: true },
          { key: "action", label: "Acciones", sortable: false },
        ],
        records: [] as IPaymentModel[],
        rowsPerPage: 10,
      } as any,
    };
  },
  async mounted() {
    await this.load();

  },
  computed: {
    filteredItems(): any {
      const q = this.table.filters.search?.toLowerCase() || "";
      return q
        ? this.table.records.filter((item: IPaymentModel) =>
          [item.Method, item.Reference, item.Status, item.Amount]
            .filter(Boolean)
            .some((v) => String(v).toLowerCase().includes(q))
        )
        : this.table.records;
    },
    rows(): number {
      return this.table.records?.length || 0;
    },
  },
  methods: {
    async load() {
      this.table.loading = true;
      if (this.record.Id > 0) {
        this.table.records = await PaymentService.GetPayments({ EnrollmentId: this.record.Id } as any);
        this.charges = await EnrollmentChargesService.GetEnrollmentCharges({ EnrollmentId: this.record.Id } as any);
      }
      this.students = await StudentService.GetStudents();
      this.table.loading = false;
    },
    async edit(data: IPaymentModel) {
      this.form.record = await PaymentService.GetPaymentById({ Id: data.Id } as any);
      this.form.dialog = true;
    },
    updateAmount() {
      const selectedCharge = this.charges.find(c => c.Id === this.form.record.ChargeId);
      if (selectedCharge) {
        this.form.record.Amount = selectedCharge.Amount;
      } else {
        this.form.record.Amount = 0;
      }
    },
    openModal() {
      this.form.record = {
        Id: 0,
        EnrollmentId: this.record?.Id,
        PaymentDate: "",
        Amount: 0,
        Method: "",
        Reference: "",
        Status: ""
      } as IPaymentModel;
      this.form.dialog = true;
    },
    async handleSubmit(event: Event) {
      event.preventDefault();
      this.form.dialog = false;
      await PaymentService.PostPayment(this.form.record);
      store.dispatch("core/popupDialog", {
        text: "Registro completado con éxito.",
        type: "success",
        showCancelButton: false,
      });
      this.load();
    },
  },
});
